import React, { useEffect } from 'react';
import WorkerReputation from './components/WorkerReputation';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Lenis from 'lenis';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Components
import ErrorBoundary from './components/ErrorBoundary';
import PageFadeIn from './components/PageFadeIn';
import SlowApiNotification from './components/SlowApiNotification';
import Landing from './components/Landing';

// Auth Pages
import Login from './components/Login';
import Register from './components/Register';
import VerifyEmail from './components/VerifyEmail';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import AdminLogin from './components/AdminLogin';

// Dashboards & Pages
import WorkerDashboard from './components/WorkerDashboard';
import BusinessDashboard from './components/BusinessDashboard';
import AdminDashboard from './components/AdminDashboard';
import TransactionHistory from './components/TransactionHistory';
import PayoutHistory from './components/PayoutHistory';
import Profile from './components/Profile';
import BusinessSpending from './components/BusinessSpending';
import AdminPayouts from './components/AdminPayouts';
import AdminRevenue from './components/AdminRevenue';
import WalletCard from './components/WalletCard';
import NotFound from './components/NotFound';
import BusinessOnboarding from './components/BusinessOnboarding';


function App() {
    useEffect(() => {
        const lenis = new Lenis({
            duration: 1.2,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            direction: 'vertical',
            smooth: true,
        });

        function raf(time) {
            lenis.raf(time);
            requestAnimationFrame(raf);
        }
        requestAnimationFrame(raf);

        return () => lenis.destroy();
    }, []);

    return (
        <ErrorBoundary>
            <Router>
                <SlowApiNotification />
                <ToastContainer 
                    position="top-right"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="dark" 
                />
                <PageFadeIn>
                    <Routes>
                        <Route path="/" element={<Landing />} />
                        
                        {/* Auth Routes */}
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/verify-email" element={<VerifyEmail />} />
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route path="/reset-password" element={<ResetPassword />} />
                        <Route path="/admin-login" element={<AdminLogin />} />

                        {/* Dashboards */}
                        <Route path="/worker-dashboard" element={<WorkerDashboard />} />
                        <Route path="/business-dashboard" element={<BusinessDashboard />} />
                        <Route path="/admin-dashboard" element={<AdminDashboard />} />

                        {/* Sub-Pages */}
                        <Route path="/worker/transactions" element={<TransactionHistory />} />
                        <Route path="/worker/payouts" element={<PayoutHistory />} />
                        <Route path="/business/spending" element={<BusinessSpending />} />
                        <Route path="/admin/payouts" element={<AdminPayouts />} />
                        <Route path="/admin/revenue" element={<AdminRevenue />} />
                        <Route path="/profile" element={<Profile />} />
                        <Route path="/business/onboarding" element={<BusinessOnboarding />} />
                        <Route path="/worker/reputation" element={<WorkerReputation />} />
                        

                        <Route path="/wallet" element={<div style={{ padding: '40px' }}><WalletCard /></div>} />
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </PageFadeIn>
            </Router>
        </ErrorBoundary>
    );
}

export default App;